// src/screens/CubaScreen.jsx
import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { getRates, getRateForAmount, openWhatsApp, getContacts, saveContact, deleteContact, isBusinessOpen, getBusinessHoursLabel, logVueloCotizacion, notifyAdminConsulta, registrarSolicitud } from '../services/authService';
import { SectionLabel, CompleteProfileModal } from '../components/UI';
import { toast } from '../components/UI';
import ViajesChat from './ViajesChat';
import VuelosGuyanaScreen from './VuelosGuyanaScreen';

const PIX_KEY = 'af171294-1b6d-4fbf-af5c-e32fb9ac7d8e';
const PIX_NAME = 'Yoedis Mena';
const MAX_CONTACTS = 10;

function PixBox() {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    navigator.clipboard.writeText(PIX_KEY);
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
    toast('¡Llave PIX copiada! 📋');
  };
  return (
    <div style={{ background: 'rgba(0,196,140,0.08)', border: '1px solid rgba(0,196,140,0.25)', borderRadius: 14, padding: '14px 16px', marginTop: 16 }}>
      <p style={{ fontSize: 11, color: 'var(--success)', fontWeight: 700, letterSpacing: 0.5, marginBottom: 6 }}>⚡ PAGO VÍA PIX</p>
      <p style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 8 }}>A nombre de <strong style={{ color: 'var(--white)' }}>{PIX_NAME}</strong> — Realiza el pago y envía el comprobante por WhatsApp.</p>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <p style={{ fontSize: 12, color: 'var(--success)', fontWeight: 600, flex: 1, wordBreak: 'break-all' }}>{PIX_KEY}</p>
        <button onClick={handleCopy} style={{ background: copied ? 'var(--success)' : 'rgba(0,196,140,0.2)', border: '1px solid rgba(0,196,140,0.4)', color: copied ? 'white' : 'var(--success)', borderRadius: 8, padding: '7px 12px', fontSize: 12, fontWeight: 700, whiteSpace: 'nowrap' }}>{copied ? '✅ Copiado' : '📋 Copiar'}</button>
      </div>
    </div>
  );
}

function ContactPicker({ uid, onSelect, onClose }) {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    getContacts(uid).then(c => { setContacts(c); setLoading(false); });
  }, [uid]);

  const handleNewContactSaved = async () => {
    setShowForm(false);
    const list = await getContacts(uid);
    setContacts(list);
    const created = list[list.length - 1];
    if (created?.phone1) onSelect({ type: 'phone', value: created.phone1, name: created.name });
    else if (created?.card1) onSelect({ type: 'card', value: created.card1, name: created.name });
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 300, display: 'flex', alignItems: 'flex-end', backdropFilter: 'blur(4px)' }}>
      <div style={{ background: 'var(--navy-light)', borderRadius: '20px 20px 0 0', width: '100%', padding: '24px 20px 36px', maxHeight: '80vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h3 style={{ fontSize: 18, fontWeight: 800 }}>Mis Contactos</h3>
          <button onClick={onClose} style={{ background: 'none', color: 'var(--muted)', fontSize: 22 }}>✕</button>
        </div>
        <button onClick={() => setShowForm(true)} style={{
          width: '100%', minHeight: 44, background: 'rgba(255,107,0,0.15)', border: '1px solid rgba(255,107,0,0.3)',
          color: 'var(--orange)', borderRadius: 10, padding: '10px 14px', fontSize: 13, fontWeight: 700, marginBottom: 16,
        }}>+ Nuevo contacto</button>
        {loading && <p style={{ color: 'var(--muted)', textAlign: 'center' }}>Cargando...</p>}
        {!loading && contacts.length === 0 && <p style={{ color: 'var(--muted)', textAlign: 'center', fontSize: 13 }}>No tienes contactos guardados aún.</p>}
        {contacts.map(c => (
          <div key={c.id} style={{ background: 'var(--navy-card)', border: '1px solid var(--navy-border)', borderRadius: 12, padding: 14, marginBottom: 10 }}>
            <p style={{ fontSize: 14, fontWeight: 700, color: 'var(--white)', marginBottom: 8 }}>👤 {c.name}</p>
            {[c.phone1, c.phone2, c.phone3].filter(Boolean).map((p, i) => (
              <button key={i} onClick={() => onSelect({ type: 'phone', value: p, name: c.name })} style={{ display: 'block', width: '100%', background: 'rgba(255,107,0,0.08)', border: '1px solid rgba(255,107,0,0.2)', borderRadius: 8, padding: '8px 12px', marginBottom: 6, textAlign: 'left', color: 'var(--orange)', fontSize: 13, fontWeight: 600 }}>📞 {p}</button>
            ))}
            {[c.card1, c.card2, c.card3].filter(Boolean).map((card, i) => (
              <button key={i} onClick={() => onSelect({ type: 'card', value: card, name: c.name })} style={{ display: 'block', width: '100%', background: 'rgba(255,184,0,0.08)', border: '1px solid rgba(255,184,0,0.2)', borderRadius: 8, padding: '8px 12px', marginBottom: 6, textAlign: 'left', color: 'var(--gold)', fontSize: 13, fontWeight: 600 }}>💳 {card}</button>
            ))}
          </div>
        ))}
      </div>
      {showForm && (
        <ContactForm uid={uid} existing={null} onSave={handleNewContactSaved} onClose={() => setShowForm(false)} />
      )}
    </div>
  );
}

function ContactForm({ uid, existing, onSave, onClose }) {
  const empty = { name: '', phone1: '', phone2: '', phone3: '', card1: '', card2: '', card3: '' };
  const [form, setForm] = useState(existing ? { name: existing.name, phone1: existing.phone1 || '', phone2: existing.phone2 || '', phone3: existing.phone3 || '', card1: existing.card1 || '', card2: existing.card2 || '', card3: existing.card3 || '' } : empty);
  const [loading, setLoading] = useState(false);
  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));
  const handleSave = async () => {
    if (!form.name.trim()) return toast('El nombre es obligatorio.', 'error');
    setLoading(true);
    try {
      await saveContact(uid, existing ? { ...form, id: existing.id } : form);
      toast('Contacto guardado ✅');
      onSave();
    } catch { toast('Error al guardar.', 'error'); }
    setLoading(false);
  };
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 300, display: 'flex', alignItems: 'flex-end', backdropFilter: 'blur(4px)' }}>
      <div style={{ background: 'var(--navy-light)', borderRadius: '20px 20px 0 0', width: '100%', padding: '24px 20px 36px', maxHeight: '90vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h3 style={{ fontSize: 18, fontWeight: 800 }}>{existing ? 'Editar contacto' : 'Nuevo contacto'}</h3>
          <button onClick={onClose} style={{ background: 'none', color: 'var(--muted)', fontSize: 22 }}>✕</button>
        </div>
        <label>NOMBRE *</label>
        <input value={form.name} onChange={set('name')} placeholder="Ej: Mamá, Pedro..." style={{ marginBottom: 16 }} />
        <p className="section-label">TELÉFONOS (opcional)</p>
        <input value={form.phone1} onChange={set('phone1')} placeholder="Teléfono 1" inputMode="tel" style={{ marginBottom: 8 }} />
        <input value={form.phone2} onChange={set('phone2')} placeholder="Teléfono 2" inputMode="tel" style={{ marginBottom: 8 }} />
        <input value={form.phone3} onChange={set('phone3')} placeholder="Teléfono 3" inputMode="tel" style={{ marginBottom: 16 }} />
        <p className="section-label">TARJETAS CUBANAS (opcional)</p>
        <input value={form.card1} onChange={set('card1')} placeholder="Tarjeta 1" inputMode="numeric" style={{ marginBottom: 8 }} />
        <input value={form.card2} onChange={set('card2')} placeholder="Tarjeta 2" inputMode="numeric" style={{ marginBottom: 8 }} />
        <input value={form.card3} onChange={set('card3')} placeholder="Tarjeta 3" inputMode="numeric" style={{ marginBottom: 20 }} />
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={onClose} className="btn-outline" style={{ flex: 1 }}>Cancelar</button>
          <button onClick={handleSave} className="btn-primary" style={{ flex: 2 }} disabled={loading}>
            {loading ? <span className="spinner" /> : '💾 Guardar'}
          </button>
        </div>
      </div>
    </div>
  );
}

function ContactsManager({ onBack }) {
  const { user } = useAuth();
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);

  const load = () => {
    if (!user?.uid) return;
    setLoading(true);
    getContacts(user.uid).then(c => { setContacts(c); setLoading(false); });
  };

  useEffect(load, [user?.uid]);

  const handleDelete = async (id, name) => {
    if (!window.confirm(`¿Eliminar el contacto "${name}"?`)) return;
    try {
      await deleteContact(id);
      setContacts(c => c.filter(x => x.id !== id));
      toast('Contacto eliminado.');
    } catch { toast('Error al eliminar.', 'error'); }
  };

  return (
    <div className="page" style={{ paddingTop: 20 }}>
      <button onClick={onBack} style={{ background: 'none', color: 'var(--muted)', fontSize: 13, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 6 }}>← Volver</button>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
        <div style={{ width: 44, height: 44, background: 'rgba(107,130,168,0.20)', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22 }}>👤</div>
        <div><h2 style={{ fontSize: 20, fontWeight: 800 }}>Mis Contactos</h2><p style={{ fontSize: 12, color: 'var(--muted)' }}>Números y tarjetas para Recargas y Remesas</p></div>
      </div>

      {contacts.length < MAX_CONTACTS && (
        <button onClick={() => { setEditing(null); setShowForm(true); }} style={{
          width: '100%', minHeight: 44, background: 'rgba(255,107,0,0.15)', border: '1px solid rgba(255,107,0,0.3)',
          color: 'var(--orange)', borderRadius: 10, padding: '10px 14px', fontSize: 13, fontWeight: 700, marginBottom: 20,
        }}>+ Nuevo contacto</button>
      )}

      {loading && <p style={{ color: 'var(--muted)', fontSize: 13, textAlign: 'center' }}>Cargando...</p>}
      {!loading && contacts.length === 0 && (
        <div style={{ background: 'var(--navy-card)', border: '1px solid var(--navy-border)', borderRadius: 14, padding: 24, textAlign: 'center' }}>
          <p style={{ fontSize: 28, marginBottom: 8 }}>👤</p>
          <p style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.6 }}>
            Guarda los datos de tus familiares en Cuba para usarlos rápido en Recargas y Remesas.
          </p>
        </div>
      )}
      {contacts.map(c => (
        <div key={c.id} style={{ background: 'var(--navy-card)', border: '1px solid var(--navy-border)', borderRadius: 14, padding: 16, marginBottom: 10 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
            <p style={{ fontSize: 15, fontWeight: 800, color: 'var(--white)' }}>👤 {c.name}</p>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => { setEditing(c); setShowForm(true); }} style={{
                minHeight: 32, background: 'rgba(255,107,0,0.12)', border: '1px solid rgba(255,107,0,0.25)',
                color: 'var(--orange)', borderRadius: 7, padding: '6px 10px', fontSize: 12, fontWeight: 600,
              }}>✏️ Editar</button>
              <button onClick={() => handleDelete(c.id, c.name)} style={{
                minHeight: 32, minWidth: 32, background: 'rgba(255,60,60,0.1)', border: '1px solid rgba(255,60,60,0.2)',
                color: 'var(--error)', borderRadius: 7, padding: '6px 10px', fontSize: 12, fontWeight: 600,
              }}>🗑️</button>
            </div>
          </div>
          {[c.phone1, c.phone2, c.phone3].filter(Boolean).map((p, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
              <span style={{ fontSize: 12 }}>📞</span>
              <span style={{ fontSize: 13, color: 'var(--off-white)' }}>{p}</span>
            </div>
          ))}
          {[c.card1, c.card2, c.card3].filter(Boolean).map((card, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
              <span style={{ fontSize: 12 }}>💳</span>
              <span style={{ fontSize: 13, color: 'var(--gold)' }}>{card}</span>
            </div>
          ))}
        </div>
      ))}
      {contacts.length >= MAX_CONTACTS && (
        <p style={{ fontSize: 11, color: 'var(--muted)', textAlign: 'center', marginTop: 8 }}>
          Límite de {MAX_CONTACTS} contactos alcanzado.
        </p>
      )}

      {showForm && (
        <ContactForm
          uid={user.uid}
          existing={editing}
          onSave={() => { setShowForm(false); setEditing(null); load(); }}
          onClose={() => { setShowForm(false); setEditing(null); }}
        />
      )}
    </div>
  );
}

// Exportados para que el Generador de Imágenes del panel de administrador
// (src/screens/admin/GeneradorImagenesPanel.jsx) pueda autocompletar los
// mismos datos ya definidos aquí, sin duplicarlos.
export const COMBOS = [
  { name: 'Combo Básico',   price: 10, cup: 120,  data: '2GB',  min: '15min',  sms: '20',  emoji: '📱' },
  { name: 'Combo Esencial', price: 20, cup: 240,  data: '4GB',  min: '35min',  sms: '40',  emoji: '📶' },
  { name: 'Combo Conecta',  price: 25, cup: 360,  data: '6GB',  min: '60min',  sms: '70',  emoji: '🌐' },
  { name: 'Combo Familiar', price: 35, cup: 480,  data: '8GB',  min: '75min',  sms: '90',  emoji: '👨‍👩‍👧' },
  { name: 'Combo Súper',    price: 50, cup: 750,  data: '12GB', min: '110min', sms: '130', emoji: '🚀' },
  { name: 'Combo Ultra',    price: 60, cup: 1000, data: '16GB', min: '155min', sms: '180', emoji: '⚡' },
];

export const TRANSLATIONS = [
  { name: 'Antecedentes Penales',            price: 115 },
  { name: 'Certificado de Nacimiento',        price: 140 },
  { name: 'Certificado de Matrimonio',        price: 140 },
  { name: 'Licencia de Conducir',             price: 100 },
  { name: 'Diplomas',                         price: 140 },
  { name: 'Certificado de Divorcio',          price: 140 },
  { name: 'Certificado de Estado Civil',      price: 130 },
  { name: 'Carta Consular',                   price: 110 },
  { name: 'Título Bachiller (Venezuela/Cuba)', price: 110 },
];

export const DOCUMENTOS_CUBA = [
  { name: 'Antecedentes Penales',      nota: 'Directamente desde MINJUS' },
  { name: 'Inscripción de Nacimiento', nota: 'Incluye gestión en Registro Civil si no la tiene' },
  { name: 'Poder Notarial',            nota: '' },
  { name: 'Declaración de Soltería',   nota: '' },
  { name: 'Certificado de Matrimonio', nota: '' },
  { name: 'Diplomas',                  nota: '' },
  { name: 'Títulos',                   nota: '' },
];

export const DOCUMENTOS_CUBA_PRICES = { minjus: 400, embajada: 350 };

function useProfileGate() {
  const { profileComplete, user } = useAuth();
  const [showProfile, setShowProfile] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);

  const requireProfile = (action) => {
    if (!profileComplete) {
      setShowProfile(true);
      setPendingAction(() => action);
      return false;
    }
    return true;
  };

  const onProfileComplete = () => {
    setShowProfile(false);
    if (pendingAction) { pendingAction(); setPendingAction(null); }
  };

  return { requireProfile, showProfile, setShowProfile, onProfileComplete, user, profileComplete };
}

function ProfileGateModal({ gate }) {
  if (!gate.showProfile || !gate.user) return null;
  return (
    <CompleteProfileModal
      uid={gate.user.uid}
      userName={gate.user?.name || ''}
      userEmail={gate.user?.email || ''}
      onComplete={gate.onProfileComplete}
      onClose={() => gate.setShowProfile(false)}
    />
  );
}

function BusinessHoursModal({ onConfirm, onCancel }) {
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 400, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, backdropFilter: 'blur(4px)' }}>
      <div style={{ background: 'var(--navy-light)', border: '1px solid rgba(255,107,0,0.3)', borderRadius: 20, padding: '28px 24px', maxWidth: 340, width: '100%', textAlign: 'center' }}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>🕐</div>
        <h3 style={{ fontSize: 17, fontWeight: 800, color: 'var(--white)', marginBottom: 10 }}>Fuera del horario comercial</h3>
        <p style={{ fontSize: 13, color: 'var(--off-white)', lineHeight: 1.6, marginBottom: 24 }}>
          Nuestro horario de atención es de <strong style={{ color: 'var(--orange)' }}>{getBusinessHoursLabel()}</strong>, todos los días.{'\n\n'}Tu mensaje llegará, pero lo atenderemos en cuanto estemos disponibles.
        </p>
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={onCancel} className="btn-outline" style={{ flex: 1 }}>Cancelar</button>
          <button onClick={onConfirm} className="btn-primary" style={{ flex: 2 }}>Enviar de todos modos</button>
        </div>
      </div>
    </div>
  );
}

function ProfileLockBanner({ onUnlock }) {
  return (
    <div style={{ background: 'rgba(255,107,0,0.08)', border: '1px solid rgba(255,107,0,0.3)', borderRadius: 14, padding: '16px', marginBottom: 20, textAlign: 'center' }}>
      <p style={{ fontSize: 20, marginBottom: 8 }}>🔒</p>
      <p style={{ fontSize: 13, fontWeight: 700, color: 'var(--white)', marginBottom: 6 }}>Completa tu perfil para ver los precios</p>
      <p style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 14, lineHeight: 1.5 }}>Solo toma un minuto y además recibes 50 CLICKs de bienvenida.</p>
      <button onClick={onUnlock} className="btn-primary" style={{ padding: '10px 24px' }}>Completar perfil →</button>
    </div>
  );
}

function Recargas({ onBack }) {
  const [selected, setSelected] = useState(null);
  const [number, setNumber] = useState('');
  const [showPicker, setShowPicker] = useState(false);
  const [showHoursModal, setShowHoursModal] = useState(false);
  const [pendingMsg, setPendingMsg] = useState(null);
  const gate = useProfileGate();

  const buildMessage = () => {
    const numberLine = number.trim() ? `\n📞 Número:\n        ${number.trim()}` : '';
    return `Hola, soy *${gate.user.name}*.\n\n📱 *Solicitud de Recarga a Cuba*\n───────────────────\n📦 Combo: *${selected.name}*\n💰 Precio: *R$ ${selected.price},00*${numberLine}\n───────────────────\n¡Aguardo confirmación para el pago!\n\nQuerido(a) usuario(a):\n📎 Si ya hiciste el Pix, envía el comprobante en este chat — sin él no podemos confirmar el pago y procesar tu solicitud.`;
  };

  const logSolicitud = () => {
    const detalle = `Combo: ${selected.name} — R$ ${selected.price},00${number.trim() ? ` — Número: ${number.trim()}` : ''}`;
    registrarSolicitud({ uid: gate.user.uid, tipo: 'Recargas', detalle }).catch(err => console.error('No se pudo registrar la solicitud:', err));
  };

  const handleSend = () => {
    if (!selected) return toast('Selecciona un combo.', 'error');
    if (!number.trim()) return toast('Ingresa el número de Cuba.', 'error');
    const send = () => {
      const msg = buildMessage();
      if (!isBusinessOpen()) { setPendingMsg(msg); setShowHoursModal(true); return; }
      openWhatsApp(msg);
      notifyAdminConsulta('Recargas', gate.user.name);
      logSolicitud();
    };
    if (gate.requireProfile(send)) send();
  };

  const confirmSend = () => {
    openWhatsApp(pendingMsg);
    notifyAdminConsulta('Recargas', gate.user.name);
    logSolicitud();
    setShowHoursModal(false);
    setPendingMsg(null);
  };

  return (
    <div className="page" style={{ paddingTop: 20 }}>
      <button onClick={onBack} style={{ background: 'none', color: 'var(--muted)', fontSize: 13, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 6 }}>← Volver</button>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
        <div style={{ width: 44, height: 44, background: 'rgba(255,184,0,0.20)', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22 }}>📱</div>
        <div><h2 style={{ fontSize: 20, fontWeight: 800 }}>Recargas a Cuba</h2><p style={{ fontSize: 12, color: 'var(--muted)' }}>2 CLICKs por cada BRL gastado</p></div>
      </div>
      {!gate.profileComplete ? (
        <ProfileLockBanner onUnlock={() => gate.setShowProfile(true)} />
      ) : (
        <>
          <SectionLabel>ELIGE TU COMBO</SectionLabel>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 20 }}>
            {COMBOS.map(combo => (
              <button key={combo.name} onClick={() => setSelected(combo)} style={{ background: selected?.name === combo.name ? 'rgba(255,107,0,0.20)' : 'var(--navy-card)', border: `1.5px solid ${selected?.name === combo.name ? 'var(--orange)' : 'var(--navy-border)'}`, borderRadius: 14, padding: '14px 10px', textAlign: 'center', position: 'relative', transition: 'all 0.2s' }}>
                {combo.badge && <span style={{ position: 'absolute', top: -8, left: 8, background: 'var(--orange)', color: 'white', fontSize: 9, fontWeight: 800, padding: '2px 7px', borderRadius: 20 }}>{combo.badge}</span>}
                <div style={{ fontSize: 22, marginBottom: 4 }}>{combo.emoji}</div>
                <p style={{ fontSize: 10, color: 'var(--muted)', marginBottom: 2 }}>{combo.name}</p>
                <p style={{ fontSize: 22, fontWeight: 800, color: 'var(--orange)', lineHeight: 1 }}>R${combo.price}</p>
                <div style={{ background: 'var(--navy)', borderRadius: 6, padding: '3px 6px', margin: '6px auto 4px', display: 'inline-block' }}>
                  <p style={{ fontSize: 11, color: 'var(--gold)', fontWeight: 700 }}>{combo.cup} CUP</p>
                </div>
                <p style={{ fontSize: 10, color: 'var(--muted)' }}>{combo.data} + {combo.min} + {combo.sms}sms</p>
              </button>
            ))}
          </div>
          <SectionLabel>NÚMERO A RECARGAR</SectionLabel>
          <div style={{ display: 'flex', gap: 8, marginBottom: 4 }}>
            <input value={number} onChange={e => setNumber(e.target.value)} placeholder="+53 5XXX XXXX" inputMode="tel" style={{ flex: 1 }} />
            <button onClick={() => setShowPicker(true)} style={{ background: 'var(--navy-card)', border: '1px solid var(--orange)', color: 'var(--orange)', borderRadius: 10, padding: '0 14px', fontSize: 13, fontWeight: 700, whiteSpace: 'nowrap' }}>👤 Contactos</button>
          </div>
          <p style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 16 }}>O selecciona un teléfono de tus contactos guardados.</p>
          <button className="btn-primary" onClick={handleSend}>Solicitar por WhatsApp</button>
          <PixBox />
          {showPicker && gate.user && (
            <ContactPicker uid={gate.user.uid} onSelect={({ value }) => { setNumber(value); setShowPicker(false); }} onClose={() => setShowPicker(false)} />
          )}
        </>
      )}
      <ProfileGateModal gate={gate} />
      {showHoursModal && <BusinessHoursModal onConfirm={confirmSend} onCancel={() => setShowHoursModal(false)} />}
    </div>
  );
}

const MAX_TARJETAS_REMESA = 5;

function Remesas({ onBack }) {
  const [rows, setRows] = useState([{ card: '', amount: '' }]);
  const [rates, setRates] = useState({ low: 0, high: 0 });
  const [showPicker, setShowPicker] = useState(false);
  const [pickerIndex, setPickerIndex] = useState(0);
  const [showHoursModal, setShowHoursModal] = useState(false);
  const [pendingMsg, setPendingMsg] = useState(null);
  const gate = useProfileGate();

  useEffect(() => { getRates().then(setRates); }, []);

  const updateRow = (i, field, value) => {
    setRows(rs => rs.map((r, idx) => idx === i ? { ...r, [field]: value } : r));
  };
  const addRow = () => setRows(rs => rs.length < MAX_TARJETAS_REMESA ? [...rs, { card: '', amount: '' }] : rs);
  const removeRow = (i) => setRows(rs => rs.length > 1 ? rs.filter((_, idx) => idx !== i) : rs);

  // El monto manda la tasa siempre, tenga o no tenga tarjeta cargada esa fila.
  const total = rows.reduce((s, r) => s + (parseFloat(r.amount) || 0), 0);
  const isHighRate = total >= 100;
  const rate = total > 0 ? getRateForAmount(rates, total) : 0;
  const cup = rate > 0 ? Math.round(total * rate) : 0;
  // Las líneas de tarjeta destino sí necesitan el número -- sin él no hay adónde mandar el CUP.
  const withCard = rows.filter(r => r.card.trim() && (parseFloat(r.amount) || 0) > 0);

  const openContactPicker = (i) => { setPickerIndex(i); setShowPicker(true); };
  const openContactPickerSmart = () => {
    const emptyIdx = rows.findIndex(r => !r.card.trim());
    if (emptyIdx !== -1) { setPickerIndex(emptyIdx); setShowPicker(true); return; }
    if (rows.length >= MAX_TARJETAS_REMESA) return toast(`Ya tienes ${MAX_TARJETAS_REMESA} tarjetas agregadas.`, 'error');
    setPickerIndex(rows.length);
    setRows(rs => [...rs, { card: '', amount: '' }]);
    setShowPicker(true);
  };

  const buildMessage = () => {
    let cardBlock = '';
    if (rows.length === 1) {
      cardBlock = withCard.length ? `\n💳 Tarjeta destino:\n        ${withCard[0].card.trim()}` : '';
    } else if (withCard.length > 0) {
      cardBlock = '\n───────────────────\n' + withCard.map((r, i) => {
        const amt = parseFloat(r.amount) || 0;
        return `💳 Tarjeta ${i + 1}:\n        ${r.card.trim()} — R$ ${amt.toFixed(2)} → ${Math.round(amt * rate).toLocaleString('es')} CUP`;
      }).join('\n');
    }
    return `Hola, soy *${gate.user.name}*.\n\n💸 *Solicitud de Remesa a Cuba*\n───────────────────\n🇧🇷 Envío: *R$ ${total.toFixed(2)}*\n🇨🇺 Entrega: *${cup.toLocaleString('es')} CUP*\n💱 Tasa: *1 BRL = ${rate.toFixed(2)} CUP*${cardBlock}\n───────────────────\n¡Aguardo instrucciones para el depósito!\n\n*En cuanto pague, subo el comprobante en este chat.*`;
  };

  const logSolicitud = () => {
    const cardPart = withCard.length
      ? ' — ' + withCard.map((r, i) => `Tarjeta ${i + 1}: ${r.card.trim()} (R$ ${(parseFloat(r.amount) || 0).toFixed(2)})`).join(', ')
      : '';
    const detalle = `R$ ${total.toFixed(2)} → ${cup.toLocaleString('es')} CUP (tasa ${rate.toFixed(2)})${cardPart}`;
    registrarSolicitud({ uid: gate.user.uid, tipo: 'Remesas', detalle }).catch(err => console.error('No se pudo registrar la solicitud:', err));
  };

  const handleSend = () => {
    if (total <= 0) return toast('Ingresa un monto válido.', 'error');
    if (!rates.low && !rates.high) return toast('Tasa no disponible.', 'error');
    const send = () => {
      const msg = buildMessage();
      if (!isBusinessOpen()) { setPendingMsg(msg); setShowHoursModal(true); return; }
      openWhatsApp(msg);
      notifyAdminConsulta('Remesas', gate.user.name);
      logSolicitud();
    };
    if (gate.requireProfile(send)) send();
  };

  const confirmSend = () => {
    openWhatsApp(pendingMsg);
    notifyAdminConsulta('Remesas', gate.user.name);
    logSolicitud();
    setShowHoursModal(false);
    setPendingMsg(null);
  };

  return (
    <div className="page" style={{ paddingTop: 20 }}>
      <button onClick={onBack} style={{ background: 'none', color: 'var(--muted)', fontSize: 13, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 6 }}>← Volver</button>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
        <div style={{ width: 44, height: 44, background: 'rgba(0,196,140,0.20)', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22 }}>💸</div>
        <div><h2 style={{ fontSize: 20, fontWeight: 800 }}>Remesas a Cuba</h2><p style={{ fontSize: 12, color: 'var(--muted)' }}>1 CLICK por cada BRL enviado</p></div>
      </div>
      {!gate.profileComplete ? (
        <ProfileLockBanner onUnlock={() => gate.setShowProfile(true)} />
      ) : (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 20 }}>
            <div style={{ background: !isHighRate && total > 0 ? 'rgba(0,196,140,0.20)' : 'rgba(0,196,140,0.08)', border: `1px solid ${!isHighRate && total > 0 ? 'rgba(0,196,140,0.5)' : 'rgba(0,196,140,0.2)'}`, borderRadius: 14, padding: '12px 14px', transition: 'all 0.3s' }}>
              <p style={{ fontSize: 10, color: 'var(--off-white)', marginBottom: 4 }}>Menos de R$ 100</p>
              <p style={{ fontSize: 17, fontWeight: 800, color: 'var(--success)' }}>{rates.low > 0 ? `${rates.low.toFixed(2)} CUP` : '—'}</p>
              <p style={{ fontSize: 10, color: 'var(--muted)', marginTop: 1 }}>por BRL</p>
            </div>
            <div style={{ background: isHighRate && total > 0 ? 'rgba(255,184,0,0.20)' : 'rgba(255,184,0,0.08)', border: `1px solid ${isHighRate && total > 0 ? 'rgba(255,184,0,0.5)' : 'rgba(255,184,0,0.2)'}`, borderRadius: 14, padding: '12px 14px', transition: 'all 0.3s' }}>
              <p style={{ fontSize: 10, color: 'var(--off-white)', marginBottom: 4 }}>R$ 100 o más</p>
              <p style={{ fontSize: 17, fontWeight: 800, color: 'var(--gold)' }}>{rates.high > 0 ? `${rates.high.toFixed(2)} CUP` : '—'}</p>
              <p style={{ fontSize: 10, color: 'var(--muted)', marginTop: 1 }}>por BRL</p>
            </div>
          </div>

          <SectionLabel>CALCULADORA</SectionLabel>
          {rows.length === 1 && (
            <div style={{ marginBottom: 12 }}>
              <label>Monto en Reales (BRL)</label>
              <input type="number" value={rows[0].amount} onChange={e => updateRow(0, 'amount', e.target.value)} placeholder="0.00" inputMode="decimal" />
            </div>
          )}
          <div style={{ background: 'var(--navy-card)', border: '1px solid var(--navy-border)', borderRadius: 14, padding: 20, textAlign: 'center', marginBottom: 16 }}>
            {rows.length > 1 && <p style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 4 }}>Envías en total <strong style={{ color: 'var(--off-white)' }}>R$ {total.toFixed(2)}</strong></p>}
            <p style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 4 }}>El destinatario recibirá</p>
            <p style={{ fontSize: 36, fontWeight: 800, color: 'var(--gold)', lineHeight: 1 }}>{cup > 0 ? `${cup.toLocaleString('es')} CUP` : '— CUP'}</p>
            {cup > 0 && <p style={{ fontSize: 11, color: 'var(--muted)', marginTop: 6 }}>Tasa: 1 BRL = {rate.toFixed(2)} CUP{isHighRate ? ' ⭐' : ''}</p>}
            <p style={{ fontSize: 12, color: 'var(--muted)', marginTop: 4 }}>{rows.length > 1 ? 'repartido en Cuba' : 'En Cuba'}</p>
          </div>

          {rows.length === 1 ? (
            <>
              <SectionLabel>TARJETA DESTINO (OPCIONAL)</SectionLabel>
              <div style={{ display: 'flex', gap: 8, marginBottom: 4 }}>
                <input value={rows[0].card} onChange={e => updateRow(0, 'card', e.target.value)} placeholder="Número de tarjeta cubana" inputMode="numeric" style={{ flex: 1 }} />
                <button onClick={() => openContactPicker(0)} style={{ background: 'var(--navy-card)', border: '1px solid var(--orange)', color: 'var(--orange)', borderRadius: 10, padding: '0 14px', fontSize: 13, fontWeight: 700, whiteSpace: 'nowrap' }}>👤 Contactos</button>
              </div>
              <p style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 4 }}>Si lo ingresas, llegará incluido en el mensaje de WhatsApp.</p>
              <button onClick={addRow} style={{ background: 'none', border: 'none', color: 'var(--orange)', fontSize: 12, fontWeight: 700, padding: '9px 0 4px', textAlign: 'left' }}>+ ¿Vas a repartir el envío en más de una tarjeta?</button>
            </>
          ) : (
            <>
              <SectionLabel>TARJETAS DESTINO (HASTA {MAX_TARJETAS_REMESA})</SectionLabel>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 8 }}>
                {rows.map((r, i) => {
                  const has = r.card.trim() && (parseFloat(r.amount) || 0) > 0;
                  return (
                    <div key={i}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, background: 'var(--navy-card)', border: `1px ${has ? 'solid' : 'dashed'} var(--navy-border)`, opacity: has ? 1 : 0.65, borderRadius: 12, padding: '8px 8px 8px 12px' }}>
                        <span style={{ fontSize: 10, color: 'var(--muted)', width: 14, fontWeight: 700, flexShrink: 0 }}>{i + 1}</span>
                        <input value={r.card} onChange={e => updateRow(i, 'card', e.target.value)} placeholder="Número de tarjeta cubana" inputMode="numeric" style={{ flex: 1, minWidth: 0, background: 'transparent', border: 'none', padding: '6px 4px' }} />
                        <div style={{ display: 'flex', alignItems: 'center', background: 'var(--navy)', border: '1px solid var(--navy-border)', borderRadius: 8, padding: '0 8px 0 9px', width: 88, flexShrink: 0 }}>
                          <span style={{ fontSize: 12, color: 'var(--muted)' }}>R$</span>
                          <input type="number" value={r.amount} onChange={e => updateRow(i, 'amount', e.target.value)} placeholder="0" inputMode="decimal" style={{ width: '100%', textAlign: 'right', background: 'transparent', border: 'none', padding: '6px 4px' }} />
                        </div>
                        <button onClick={() => removeRow(i)} disabled={rows.length <= 1} style={{ background: 'none', border: 'none', color: 'var(--muted)', fontSize: 15, width: 22, height: 22, flexShrink: 0, visibility: rows.length <= 1 ? 'hidden' : 'visible' }}>✕</button>
                      </div>
                      {!has && (r.card.trim() || r.amount.trim()) && (
                        <p style={{ fontSize: 10, color: 'var(--muted)', marginLeft: 20, marginTop: 3, fontStyle: 'italic' }}>Falta {r.card.trim() ? 'el monto' : 'la tarjeta'} — no se incluye todavía</p>
                      )}
                    </div>
                  );
                })}
              </div>
              <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
                <button onClick={addRow} disabled={rows.length >= MAX_TARJETAS_REMESA} style={{ flex: 1, background: 'transparent', border: '1px solid var(--orange)', color: 'var(--orange)', fontWeight: 700, fontSize: 12, borderRadius: 10, padding: '10px 8px', opacity: rows.length >= MAX_TARJETAS_REMESA ? 0.4 : 1 }}>{rows.length >= MAX_TARJETAS_REMESA ? `Máximo ${MAX_TARJETAS_REMESA} tarjetas` : '+ Agregar tarjeta'}</button>
                <button onClick={openContactPickerSmart} style={{ flex: 1, background: 'transparent', border: '1px solid var(--orange)', color: 'var(--orange)', fontWeight: 700, fontSize: 12, borderRadius: 10, padding: '10px 8px' }}>👤 Contactos</button>
              </div>
              <p style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 20 }}>Pon un monto por cada tarjeta. Las que dejes sin monto no se incluyen en la solicitud.</p>
            </>
          )}

          <button className="btn-primary" onClick={handleSend}>Solicitar por WhatsApp</button>
          <PixBox />
          {showPicker && gate.user && (
            <ContactPicker uid={gate.user.uid} onSelect={({ value }) => { updateRow(pickerIndex, 'card', value); setShowPicker(false); }} onClose={() => setShowPicker(false)} />
          )}
        </>
      )}
      <ProfileGateModal gate={gate} />
      {showHoursModal && <BusinessHoursModal onConfirm={confirmSend} onCancel={() => setShowHoursModal(false)} />}
    </div>
  );
}

function VuelosChoice({ onSelect, onBack }) {
  return (
    <div className="page" style={{ paddingTop: 20 }}>
      <button onClick={onBack} style={{ background: 'none', color: 'var(--muted)', fontSize: 13, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 6 }}>← Volver</button>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
        <div style={{ width: 44, height: 44, background: 'rgba(255,107,0,0.22)', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22 }}>✈️</div>
        <div><h2 style={{ fontSize: 20, fontWeight: 800 }}>Vuelos</h2><p style={{ fontSize: 12, color: 'var(--muted)' }}>Elige cómo quieres cotizar</p></div>
      </div>

      <button onClick={() => onSelect('vuelos_guyana')} style={{
        width: '100%', textAlign: 'left', background: 'rgba(255,107,0,0.10)',
        border: '1.5px solid var(--orange)', borderRadius: 16, padding: 18,
        marginBottom: 14, position: 'relative', overflow: 'hidden',
      }}>
        <span style={{ position: 'absolute', top: 12, right: 12, background: 'var(--orange)', color: 'white', fontSize: 9, fontWeight: 800, letterSpacing: 0.5, padding: '3px 8px', borderRadius: 20 }}>FECHAS REALES</span>
        <p style={{ fontSize: 17, fontWeight: 800, color: 'var(--white)', marginBottom: 6 }}>🌴 Vuelos Guyana</p>
        <p style={{ fontSize: 12.5, color: 'var(--off-white)', lineHeight: 1.5 }}>Rutas, precios y cupos reales actualizados — elige tu ciudad y reserva al instante.</p>
      </button>

      <button onClick={() => onSelect('cotizador')} style={{
        width: '100%', textAlign: 'left', background: 'var(--navy-card)',
        border: '1px solid var(--navy-border)', borderRadius: 16, padding: 18,
      }}>
        <p style={{ fontSize: 17, fontWeight: 800, color: 'var(--white)', marginBottom: 6 }}>📝 Cotizador</p>
        <p style={{ fontSize: 12.5, color: 'var(--muted)', lineHeight: 1.5 }}>Para cualquier otro destino — completa el formulario y te cotizamos por WhatsApp.</p>
      </button>
    </div>
  );
}

function Vuelos({ onBack }) {
  const [form, setForm] = useState({ origin: '', dest: '', date: '', returnDate: '', adults: 1, infants: 0, roundTrip: false });
  const { user } = useAuth();
  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSend = () => {
    if (!form.origin || !form.dest || !form.date) return toast('Completa origen, destino y fecha.', 'error');

    // Registro silencioso para el sistema de referidos: nunca debe bloquear
    // ni retrasar el envío del WhatsApp al cliente, por eso no se espera (await).
    if (user?.uid) {
      logVueloCotizacion({
        uid: user.uid,
        referredBy: user.referred_by || null,
        origen: form.origin,
        destino: form.dest,
        fechaSolicitada: form.date,
        adultos: parseInt(form.adults) || 1,
        infantes: parseInt(form.infants) || 0,
      }).catch(err => console.error('No se pudo registrar la cotización de vuelo:', err));
    }

    openWhatsApp(`Buenas noches, te saluda *${user?.name || ''}*.\n\n✈️ *Solicitud de Cotización de Vuelo*\n───────────────────\n🛫 Origen: *${form.origin}*\n🛬 Destino: *${form.dest}*\n📅 Salida: *${form.date}*${form.roundTrip && form.returnDate ? `\n🔄 Regreso: *${form.returnDate}*` : ''}\n🧭 Tipo: *${form.roundTrip ? 'Ida y Vuelta' : 'Solo Ida'}*\n👤 Adultos: *${form.adults}*${form.infants > 0 ? `\n👶 Infantes: *${form.infants}*` : ''}\n───────────────────\n¡Por favor envíame las opciones disponibles!`);
    notifyAdminConsulta('Vuelos', user?.name || '');
    if (user?.uid) {
      const detalle = `${form.origin} → ${form.dest} — ${form.date}${form.roundTrip ? ` (ida y vuelta, regreso ${form.returnDate})` : ' (solo ida)'} — Adultos: ${form.adults}${form.infants > 0 ? `, Infantes: ${form.infants}` : ''}`;
      registrarSolicitud({ uid: user.uid, tipo: 'Vuelos', detalle }).catch(err => console.error('No se pudo registrar la solicitud:', err));
    }
  };

  return (
    <div className="page" style={{ paddingTop: 20 }}>
      <button onClick={onBack} style={{ background: 'none', color: 'var(--muted)', fontSize: 13, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 6 }}>← Volver</button>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
        <div style={{ width: 44, height: 44, background: 'rgba(255,107,0,0.22)', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22 }}>✈️</div>
        <div><h2 style={{ fontSize: 20, fontWeight: 800 }}>Vuelos</h2><p style={{ fontSize: 12, color: 'var(--muted)' }}>Cotización personalizada y gratuita</p></div>
      </div>
      <div style={{ marginBottom: 14 }}>
        <label>Origen</label>
        <input value={form.origin} onChange={set('origin')} placeholder="Ej: La Habana, Santiago de Cuba..." />
      </div>
      <div style={{ marginBottom: 14 }}>
        <label>Destino</label>
        <input value={form.dest} onChange={set('dest')} placeholder="Ej: São Paulo, Guyana..." />
      </div>
      <div style={{ marginBottom: 14 }}>
        <label>Fecha de salida</label>
        <input type="date" value={form.date} onChange={set('date')} />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
        <input type="checkbox" id="roundTrip" checked={form.roundTrip} onChange={e => setForm(f => ({ ...f, roundTrip: e.target.checked }))} style={{ width: 18, height: 18, accentColor: 'var(--orange)' }} />
        <label htmlFor="roundTrip" style={{ fontSize: 13, color: 'var(--off-white)', textTransform: 'none', letterSpacing: 0, fontWeight: 400 }}>Ida y vuelta</label>
      </div>
      {form.roundTrip && (
        <div style={{ marginBottom: 14 }}>
          <label>Fecha de regreso</label>
          <input type="date" value={form.returnDate} onChange={set('returnDate')} />
        </div>
      )}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 20 }}>
        <div>
          <label>Adultos</label>
          <input type="number" value={form.adults} onChange={set('adults')} min="1" max="9" inputMode="numeric" />
        </div>
        <div>
          <label>Infantes (0-2 años)</label>
          <input type="number" value={form.infants} onChange={set('infants')} min="0" max="9" inputMode="numeric" />
        </div>
      </div>
      <button className="btn-primary" onClick={handleSend}>Solicitar cotización por WhatsApp</button>
    </div>
  );
}

function Traducciones({ onBack }) {
  const gate = useProfileGate();
  const [showHoursModal, setShowHoursModal] = useState(false);
  const [pendingMsg, setPendingMsg] = useState(null);
  const [pendingDetalle, setPendingDetalle] = useState(null);

  const handleSend = (item) => {
    const msg = `Hola, soy *${gate.user.name}*.\n\n📄 *Solicitud de Traducción Juramentada*\n───────────────────\n📋 Documento: *${item.name}*\n💰 Valor: *R$ ${item.price},00*\n───────────────────\n¡Aguardo instrucciones para enviar el documento y realizar el pago!`;
    const detalle = `${item.name} — R$ ${item.price},00`;
    const logSolicitud = () => {
      registrarSolicitud({ uid: gate.user.uid, tipo: 'Traducciones', detalle }).catch(err => console.error('No se pudo registrar la solicitud:', err));
    };
    const send = () => {
      if (!isBusinessOpen()) { setPendingMsg(msg); setPendingDetalle(detalle); setShowHoursModal(true); return; }
      openWhatsApp(msg);
      notifyAdminConsulta('Traducciones', gate.user.name);
      logSolicitud();
    };
    if (gate.requireProfile(send)) send();
  };

  const confirmSend = () => {
    openWhatsApp(pendingMsg);
    notifyAdminConsulta('Traducciones', gate.user.name);
    registrarSolicitud({ uid: gate.user.uid, tipo: 'Traducciones', detalle: pendingDetalle }).catch(err => console.error('No se pudo registrar la solicitud:', err));
    setShowHoursModal(false);
    setPendingMsg(null);
    setPendingDetalle(null);
  };

  return (
    <div className="page" style={{ paddingTop: 20 }}>
      <button onClick={onBack} style={{ background: 'none', color: 'var(--muted)', fontSize: 13, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 6 }}>← Volver</button>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
        <div style={{ width: 44, height: 44, background: 'rgba(107,138,255,0.20)', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22 }}>📄</div>
        <div><h2 style={{ fontSize: 20, fontWeight: 800 }}>Traducciones Juramentadas</h2><p style={{ fontSize: 12, color: 'var(--muted)' }}>Plazo: 24h a 36h · 1 CLICK por BRL</p></div>
      </div>
      <div style={{ background: 'rgba(107,138,255,0.12)', border: '1px solid rgba(107,138,255,0.25)', borderRadius: 10, padding: '10px 14px', marginBottom: 16 }}>
        <p style={{ fontSize: 12, color: 'var(--off-white)' }}>El plazo inicia desde la confirmación del pago y recepción del documento.</p>
      </div>
      {!gate.profileComplete ? (
        <ProfileLockBanner onUnlock={() => gate.setShowProfile(true)} />
      ) : (
        <div style={{ marginTop: 16 }}>
          <SectionLabel>TARIFARIO</SectionLabel>
          {TRANSLATIONS.map(item => (
            <div key={item.name} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'var(--navy-card)', border: '1px solid var(--navy-border)', borderRadius: 12, padding: '14px', marginBottom: 8 }}>
              <div style={{ flex: 1, marginRight: 10 }}>
                <p style={{ fontSize: 13, fontWeight: 600, color: 'var(--white)' }}>{item.name}</p>
                <p style={{ fontSize: 15, fontWeight: 800, color: 'var(--gold)', marginTop: 2 }}>R$ {item.price},00</p>
              </div>
              <button onClick={() => handleSend(item)} style={{ background: 'var(--orange)', color: 'white', fontWeight: 700, fontSize: 12, borderRadius: 8, padding: '9px 14px', whiteSpace: 'nowrap' }}>Traducir →</button>
            </div>
          ))}
          <div style={{ background: 'var(--navy-card)', border: '1px solid var(--navy-border)', borderRadius: 12, padding: 14, marginTop: 4 }}>
            <p style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.6, fontStyle: 'italic' }}>Otros tipos de documentos: se hace consulta para fijar valores y plazos.</p>
          </div>
          <PixBox />
        </div>
      )}
      <ProfileGateModal gate={gate} />
      {showHoursModal && <BusinessHoursModal onConfirm={confirmSend} onCancel={() => setShowHoursModal(false)} />}
    </div>
  );
}

function DocumentosCuba({ onBack }) {
  const gate = useProfileGate();

  const handleSend = (doc) => {
    const send = () => openWhatsApp(`Hola, soy *${gate.user.name}*.\n\n🏛️ *Solicitud: Documentos en Cuba*\n───────────────────\n📋 Documento: *${doc.name}*\n───────────────────\nNecesito información sobre plazos y forma de pago. ¡Gracias!`);
    if (gate.requireProfile(send)) send();
  };

  return (
    <div className="page" style={{ paddingTop: 20 }}>
      <button onClick={onBack} style={{ background: 'none', color: 'var(--muted)', fontSize: 13, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 6 }}>← Volver</button>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
        <div style={{ width: 44, height: 44, background: 'rgba(255,184,0,0.20)', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22 }}>🏛️</div>
        <div><h2 style={{ fontSize: 20, fontWeight: 800 }}>Documentos en Cuba</h2><p style={{ fontSize: 12, color: 'var(--muted)' }}>MINJUS + Embajada de Brasil</p></div>
      </div>
      <div style={{ background: 'rgba(107,138,255,0.08)', border: '1px solid rgba(107,138,255,0.2)', borderRadius: 10, padding: '10px 14px', marginBottom: 20 }}>
        <p style={{ fontSize: 12, color: 'var(--off-white)', lineHeight: 1.6 }}>📄 Entrega en formato <strong style={{ color: 'var(--white)' }}>PDF</strong>. Gestión incluida desde Cuba hasta Brasil.</p>
      </div>
      {!gate.profileComplete ? (
        <ProfileLockBanner onUnlock={() => gate.setShowProfile(true)} />
      ) : (
        <>
          <SectionLabel>DOCUMENTOS DISPONIBLES</SectionLabel>
          {DOCUMENTOS_CUBA.map(doc => (
            <div key={doc.name} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'var(--navy-card)', border: '1px solid var(--navy-border)', borderRadius: 12, padding: '14px', marginBottom: 8 }}>
              <div style={{ flex: 1, marginRight: 10 }}>
                <p style={{ fontSize: 13, fontWeight: 600, color: 'var(--white)' }}>{doc.name}</p>
                {doc.nota ? <p style={{ fontSize: 11, color: 'var(--muted)', marginTop: 3, lineHeight: 1.4 }}>{doc.nota}</p> : null}
              </div>
              <button onClick={() => handleSend(doc)} style={{ background: 'var(--orange)', color: 'white', fontWeight: 700, fontSize: 12, borderRadius: 8, padding: '9px 14px', whiteSpace: 'nowrap' }}>Consultar →</button>
            </div>
          ))}
          <PixBox />
        </>
      )}
      <ProfileGateModal gate={gate} />
    </div>
  );
}

function CambioDivisas({ onBack }) {
  const gate = useProfileGate();
  const [rates, setRates] = React.useState(null);

  React.useEffect(() => {
    getRates().then(r => setRates(r));
  }, []);

  const handleSend = (direction) => {
    const labels = {
      'brl-usd': 'Recibo BRL en Brasil → Entrego USD en La Habana',
      'usd-brl': 'Recibo USD en La Habana → Entrego BRL en Brasil',
    };
    const send = () => openWhatsApp(`Hola, soy *${gate.user.name}*.\n\n💵 *Solicitud: Cambio de Divisas*\n───────────────────\n🔄 Operación: *${labels[direction]}*\n───────────────────\nNecesito información sobre el tipo de cambio. ¡Gracias!`);
    if (gate.requireProfile(send)) send();
  };

  return (
    <div className="page" style={{ paddingTop: 20 }}>
      <button onClick={onBack} style={{ background: 'none', color: 'var(--muted)', fontSize: 13, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 6 }}>← Volver</button>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
        <div style={{ width: 44, height: 44, background: 'rgba(0,196,140,0.20)', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22 }}>💵</div>
        <div><h2 style={{ fontSize: 20, fontWeight: 800 }}>Cambio de Divisas</h2><p style={{ fontSize: 12, color: 'var(--muted)' }}>BRL ↔ USD entre Brasil y Cuba</p></div>
      </div>
      {!gate.profileComplete ? (
        <ProfileLockBanner onUnlock={() => gate.setShowProfile(true)} />
      ) : (
        <>
          {rates && (rates.brlToUsd > 0 || rates.usdToBrl > 0) && (
            <div style={{ background: 'var(--navy-card)', border: '1px solid var(--navy-border)', borderRadius: 16, padding: 16, marginBottom: 20 }}>
              <p style={{ fontSize: 11, color: 'var(--orange)', fontWeight: 700, letterSpacing: 1, marginBottom: 12 }}>TASAS DEL DÍA</p>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                {rates.brlToUsd > 0 && (
                  <div style={{ textAlign: 'center' }}>
                    <p style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 4 }}>🇧🇷 BRL → USD 🇺🇸</p>
                    <p style={{ fontSize: 22, fontWeight: 800, color: 'var(--success)' }}>{rates.brlToUsd.toFixed(2)}</p>
                    <p style={{ fontSize: 10, color: 'var(--muted)' }}>BRL por 1 USD</p>
                  </div>
                )}
                {rates.usdToBrl > 0 && (
                  <div style={{ textAlign: 'center' }}>
                    <p style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 4 }}>🇺🇸 USD → BRL 🇧🇷</p>
                    <p style={{ fontSize: 22, fontWeight: 800, color: 'var(--gold)' }}>{rates.usdToBrl.toFixed(2)}</p>
                    <p style={{ fontSize: 10, color: 'var(--muted)' }}>USD por 1 BRL</p>
                  </div>
                )}
              </div>
            </div>
          )}
          {[
            { direction: 'brl-usd', flag1: '🇧🇷', flag2: '🇨🇺', title: 'Brasil → Cuba', desc: 'Envías BRL en Brasil\nRecibes USD en La Habana' },
            { direction: 'usd-brl', flag1: '🇨🇺', flag2: '🇧🇷', title: 'Cuba → Brasil', desc: 'Envías USD en La Habana\nRecibes BRL en Brasil' },
          ].map(op => (
            <div key={op.direction} style={{ background: 'var(--navy-card)', border: '1px solid var(--navy-border)', borderRadius: 16, padding: 20, marginBottom: 12 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <span style={{ fontSize: 24 }}>{op.flag1}</span>
                <span style={{ color: 'var(--orange)', fontWeight: 700, fontSize: 18 }}>→</span>
                <span style={{ fontSize: 24 }}>{op.flag2}</span>
                <span style={{ fontSize: 15, fontWeight: 700, marginLeft: 4, color: 'var(--white)' }}>{op.title}</span>
              </div>
              <p style={{ fontSize: 13, color: 'var(--off-white)', lineHeight: 1.6, marginBottom: 16, whiteSpace: 'pre-line' }}>{op.desc}</p>
              <button onClick={() => handleSend(op.direction)} className="btn-primary" style={{ padding: '11px 20px' }}>Consultar cotización</button>
            </div>
          ))}
        </>
      )}
      <ProfileGateModal gate={gate} />
    </div>
  );
}

export const SERVICES = [
  { id: 'recargas',     icon: '📱', label: 'Recargas',            sub: 'Desde R$ 10',          color: 'rgba(255,184,0,0.20)',   active: true  },
  { id: 'remesas',      icon: '💸', label: 'Remesas',             sub: 'BRL → CUP',            color: 'rgba(0,196,140,0.20)',   active: true  },
  { id: 'contactos',    icon: '👤', label: 'Mis Contactos',       sub: 'Números y tarjetas',   color: 'rgba(107,130,168,0.20)', active: true  },
  { id: 'vuelos',       icon: '✈️', label: 'Vuelos',              sub: 'Cotización gratis',    color: 'rgba(255,107,0,0.22)',   active: true  },
  { id: 'cambio',       icon: '💵', label: 'Cambio Divisas',      sub: 'BRL ↔ USD',            color: 'rgba(0,196,140,0.20)',   active: true  },
  { id: 'traducciones', icon: '📄', label: 'Traducciones',        sub: 'Juramentadas',         color: 'rgba(107,138,255,0.22)', active: true  },
  { id: 'documentos',   icon: '🏛️', label: 'Docs en Cuba',       sub: 'MINJUS + Embajada',    color: 'rgba(255,184,0,0.20)',   active: true  },
  { id: 'paqueteria',   icon: '📦', label: 'Paquetería',          sub: 'Próximamente',         color: 'rgba(107,130,168,0.10)', active: false },
];

export default function CubaScreen({ initialService }) {
  const [active, setActive] = useState(initialService || null);
  useEffect(() => { if (initialService) setActive(initialService); }, [initialService]);

  if (active === 'recargas')     return <Recargas       onBack={() => setActive(null)} />;
  if (active === 'remesas')      return <Remesas        onBack={() => setActive(null)} />;
  if (active === 'contactos')    return <ContactsManager onBack={() => setActive(null)} />;
  if (active === 'vuelos')       return <VuelosChoice   onSelect={setActive} onBack={() => setActive(null)} />;
  if (active === 'vuelos_guyana') return <VuelosGuyanaScreen onBack={() => setActive('vuelos')} />;
  if (active === 'cotizador')    return <Vuelos         onBack={() => setActive('vuelos')} />;
  if (active === 'traducciones') return <Traducciones   onBack={() => setActive(null)} />;
  if (active === 'documentos')   return <DocumentosCuba onBack={() => setActive(null)} />;
  if (active === 'cambio')       return <CambioDivisas  onBack={() => setActive(null)} />;
  if (active === 'asistente')    return <ViajesChat     onBack={() => setActive(null)} />;

  return (
    <div className="page" style={{ paddingTop: 24 }}>
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 24, fontWeight: 800, color: 'var(--white)' }}>🇨🇺 Conexión Cuba</h2>
        <p style={{ fontSize: 13, color: 'var(--muted)', marginTop: 4 }}>Todos nuestros servicios en un solo lugar</p>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
        {SERVICES.map(svc => (
          <button key={svc.id} onClick={() => svc.active && setActive(svc.id)} disabled={!svc.active} style={{
            background: svc.color,
            border: `1.5px solid ${svc.active ? svc.color.replace(/[\d.]+\)$/, '0.5)') : 'var(--navy-border)'}`,
            borderRadius: 16, padding: '18px 14px', textAlign: 'left',
            position: 'relative', overflow: 'hidden',
            cursor: svc.active ? 'pointer' : 'default',
            transition: 'all 0.2s', opacity: svc.active ? 1 : 0.5,
          }}>
            <div style={{ fontSize: 28, marginBottom: 10 }}>{svc.icon}</div>
            <p style={{ fontSize: 13, fontWeight: 800, color: 'var(--white)' }}>{svc.label}</p>
            <p style={{ fontSize: 11, color: svc.active ? 'var(--off-white)' : 'var(--muted)', marginTop: 3 }}>{svc.sub}</p>
            {!svc.active && (
              <div style={{ position: 'absolute', top: 8, right: 8, background: 'var(--navy-border)', borderRadius: 6, padding: '2px 7px', fontSize: 9, fontWeight: 700, color: 'var(--muted)' }}>PRONTO</div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
